<template>
  <div>
    <van-cell>
      <van-radio-group v-model="isShowNoRefundReason" @change="headschange()">
        <van-radio
          name="1"
          class="shanp"
          :class="{ margin_bot: isShowNoRefundReason === '2' }"
        >
          {{ title }}
        </van-radio>
        <!-- 自愿改签的 -------------------------------------------------------->
        <van-radio-group
          v-model="checked"
          @change="getResultschange()"
          v-if="isShowNoRefundReason == '1'"
        >
          <van-cell>
            <div
              v-for="(info, index) in Refundlisty"
              :key="index"
              class="van_box"
            >
              <van-radio :name="info.cName" shape="square" icon-size="16px">
                {{ info.cName }}
              </van-radio>
            </div>
            <!-- 暂时先保留，以防未来还需要 -->
            <!-- <div>
              <van-radio name="04271202" shape="square" icon-size="16px"
              >其它</van-radio
              >
            </div>

            <van-row class="shadow">
              <van-field
                v-if="manual"
                v-model="refundResaonNonew.message"
                required
                rows="2"
                autosize
                label="原因"
                type="textarea"
                maxlength="5000"
                placeholder="原因必填,请输入原因"
                show-word-limit
              />
            </van-row> -->
            <!-- 暂时先保留，以防未来还需要 -->
          </van-cell>
        </van-radio-group>
        <van-radio name="2" class="shanp"> {{ titleto }} </van-radio>
        <span class="spanshee">
          <van-icon name="warning" style="color: red" />
          <div class="noExitTip">
            由于航班取消、提前、延误、航程改变或其他突发状况，造成您不能正常乘机，您可申请
          </div>
        </span>
        <!--非自愿改签  -->
        <van-radio-group
          v-model="checkedno"
          @change="getResultschange()"
          v-if="isShowNoRefundReason != '1'"
        >
          <van-cell>
            <div
              v-for="(info, index) in RefundlistN"
              :key="index"
              class="van_box"
            >
              <van-radio :name="info.cName" shape="square" icon-size="16px">
                {{ info.cName }}
              </van-radio>
            </div>
            <!-- 暂时先保留，以防未来还需要 -->
            <!-- <div>
              <van-radio name="04271202" shape="square" icon-size="16px"
              >其它</van-radio
              >
            </div>
            <van-row class="shadow">
              <van-field
                v-if="manualno"
                v-model="refundResaonNonew.message"
                required
                rows="2"
                autosize
                label="原因"
                type="textarea"
                maxlength="5000"
                placeholder="原因必填,请输入原因"
                show-word-limit
              />
            </van-row>
            <van-cell-group>
              <van-cell title="上传附件" />

              <van-notice-bar mode="closeable">
                图片单张不超过5MB，最多支持9张！
              </van-notice-bar>
              <van-cell>
                <van-uploader
                  v-model="fileList"
                  multiple
                  :max-count="9"
                  :before-read="beforeRead"
                  :after-read="afterRead"
                />
              </van-cell>
            </van-cell-group> -->
            <!-- 暂时先保留，以防未来还需要 -->
            <ld-uploader
              class="mt5 round-sm overflow"
              v-if="orderId"
              :order-id="orderId"
              :glywlx="'11002'"
              :cjlx="2"
            />
          </van-cell>
        </van-radio-group>
      </van-radio-group>
    </van-cell>
  </div>
</template>

<script>
import {
  Cell,
  CellGroup,
  Field,
  Checkbox,
  Tag,
  Popup,
  Collapse,
  CollapseItem,
  Icon,
  NoticeBar,
  Uploader,
  Toast,
  Button,
  Form,
  Dialog,
  RadioGroup,
  Radio,
} from "vant";
import checkListManual from "Components/ldCheckList/components/checkListManual";
import ldUploader from "Components/ldUploader";
import { localget } from "Utils/storage.js";
import { API_DEFAULT_CONFIG } from "Config";
import axios from "axios";
export default {
  name: "RefundReason",
  components: {
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    "van-cell": Cell,
    checkListManual,
    [Field.name]: Field,
    [Icon.name]: Icon,
    [NoticeBar.name]: NoticeBar,
    [Uploader.name]: Uploader,
    ldUploader,
  },
  props: {
    refundResaon: "", //退票原因
    // isShowNoRefundReason: 1, //自愿还是非自愿
    total: {
      type: [Number, String],
    },
    title:{
      type:String,
      default:"自愿退票"
    },
    titleto:{
      type:String,
      default:"非自愿退票"
    },
    chanrund: "",
    refundResaonNonew: "",
    orderId: "",
    orderPamsCode: "",
    orderPamsCodeNo: ""
  },
  
  data() {
    return {
      manual: false, //自愿是否打开手工录入
      manualno:false,//非自愿是否打开手工录入
      list: [],
      checked: "",
      checkedno: "",
      isShowNoRefundReason: "1",
      Refundlisty: [], //自愿
      RefundlistN: [], //no自愿望
      message: "",
      fileList: [],
    };
  },
  created() {
    this.Refundaxios();
  },
  methods: {
    // beforeRead(file) {
    //   this.$emit("beforeRead",file);
    // },
    // afterRead(file) {
    //   this.$emit("afterRead",file);
    // },
    // 返回布尔值
    beforeRead(file) {
      if (file instanceof Array) {
        // 判断是否是数组
        file.forEach((v) => {
          this.checkFile(v);
        });
      } else {
        this.checkFile(file);
      }
      return true;
    },
    // 图片类型检查
    checkFile(file) {
      const format = ["jpg", "png", "jpeg"];
      const index = file.name.lastIndexOf(".");
      const finalName = file.name.substr(index + 1);
      if (!format.includes(finalName.toLowerCase())) {
        Toast("请上传" + format.join(",") + "格式图片");
        return false;
      }
    },
    afterRead(file) {
      if (file instanceof Array) {
        file.map((v) => {
          v.status = "uploading";
          v.message = "上传中...";
          this.uploadImg(v);
        });
      } else {
        file.status = "uploading";
        file.message = "上传中...";
        this.uploadImg(file);
      }
    },
    // 上传
    uploadImg(file) {
      const formData = new FormData();
      formData.append("file", file.file);
      formData.append("token", localget("access_token"));
      formData.append("sysCode", 7000);
      formData.append("timeout", -1);
      let uploadUrl = API_DEFAULT_CONFIG.URL.uploadFileUrl;
      // let uploadUrl = 'http://oss.tmc.tianxiafen.com/ser/parentSystemDfs/1.0.0/file/web/upload';
      axios
        .post(uploadUrl, formData, {
          headers: this.headers,
        })
        .then((res) => {
          if (res.data && res.data.data) {
            file.status = "success";
            file.message = "";
            file.url = res.data.data;
          }
        })
        .catch((err) => {
          this.$notify({
            type: "warning",
            message: "上传失败",
          });
        });
    },

    //删除
    delUploadImg(item) {
      this.fileList = this.fileList.filter((v) => v.url != item.url);
    },
    //调取退票原因
    async Refundaxios() {
      let res = await this.$api["common/getBClass"]({ parNo: this.orderPamsCode });
      let res2 = await this.$api["common/getBClass"]({ parNo: this.orderPamsCodeNo });
      let cache1 = res.data.list || {};
      let cache2 = res2.data.list || {};
      this.Refundlisty = cache1;
      this.RefundlistN = cache2;
    },
    headschange() {
      this.craftcause()
    },
    getResultschange() {
      this.craftcause()
    },
    craftcause(){
      if(this.checked == "04271202" && this.isShowNoRefundReason == "1"){
        this.manual = true
      }else{
        this.manual = false
        this.refundResaonNonew.message=''
      }
      if(this.checkedno == "04271202" && this.isShowNoRefundReason != "1"){
        this.manualno = true
      }else{
        this.manualno = false
        this.refundResaonNonew.message=''
      }
      this.isShowNoRefundReason == "1" ? this.$emit("takein", this.checked, this.isShowNoRefundReason) : this.$emit("takein", this.checkedno, this.isShowNoRefundReason);
    }
  },
  watch: {
    fileList(newFileList) {
      // 监听 fileList 的变化并触发事件
      this.$emit("fileList", newFileList);
    },
  },
};
</script>

<style lang="less" scoped>
.van_box {
  margin-bottom: 10px;
}
.shanp {
  display: flex;
}
/deep/ .shanp .van-radio__label {
  font-size: 18px;
  font-weight: 600;
  color: #1d8ee2;
}
.margin_bot {
  margin-bottom: 10px;
}
.noExitTip {
  color: #dc8157;
  font-size: 10px;
  line-height: 13px;
}
.spanshee {
  display: flex;
  /* margin: 11px; */
  margin: 10px 0px 0px 25px;
}
</style>